<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title style="font-weight: bold; font-size: 1.60em; margin-bottom: 3px">
        Congratulations!
      </v-card-title>
      <v-card-text>
        <v-row class="pa-3">
          <div style="text-align: start; font-weight: bold">
            You have successfully registered for HawkSoft Marketplace.
          </div>
        </v-row>
        <v-row class="pa-3">
          <div>
            In order to access the full HawkSoft Marketplace, please close this window and relaunch Marketplace from the Setup <v-icon>mdi-settings</v-icon> menu in HawkSoft CMS.
          </div>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'RegistrationSuccess'
};

</script>
